import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCommonContext } from "contexts/CommonContext";

interface ScrollToTopOptions {
  deps?: any[];
  smooth?: boolean;
}

export const useScrollToTop = ({
  deps = [],
  smooth = true,
}: ScrollToTopOptions = {}) => {
  const { pathname } = useLocation();
  const { setOpenMenuBoxMobile } = useCommonContext();

  useEffect(() => {
    setOpenMenuBoxMobile(false);
    window.scrollTo({ top: 0, behavior: smooth ? "smooth" : "auto" });
  }, [pathname, smooth]);

  useEffect(() => {
    if (deps.length > 0) {
      setOpenMenuBoxMobile(false);
      window.scrollTo({ top: 0, behavior: smooth ? "smooth" : "auto" });
    }
  }, deps);
};
